/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RepresentativeContractStatus} from "./representativeContractStatus.zod";

export const RepresentativeContractDto = zod.object({
  contractedAt: zod.iso.date(),
  durationMonths: zod.int().min(1),
  expiresOn: zod.iso.date(),
  status: RepresentativeContractStatus,
});

export type RepresentativeContractDto = zod.input<typeof RepresentativeContractDto>;
export type RepresentativeContractDtoOutput = zod.output<typeof RepresentativeContractDto>;
